import { Injector } from "@angular/core";

export class ServiceLocator {
    static injector: Injector;

    static setInjector(injector: Injector) {
        ServiceLocator.injector = injector;
    }
}
